import EnhancedCustomerAutoComplete from "./CustomerAutoComplete";

export default EnhancedCustomerAutoComplete;
